export default __webpack_public_path__ + "static/media/headphone-jack.996b5d44.svg";